module.exports = __webpack_public_path__ + "img/Font 07.6dd619d9.jpg";